
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { HelpCenterVersionsEntry } from '@/help-center/types/help-center-version-entry';
import { HelpCenterFIContactInfo } from '@/help-center/types/help-center-fi-contact-info';
import { HelpCenterHelper } from '@/help-center/helper';

const helpCenterNamespace = namespace('helpCenter');

@Component
export default class HelpCenterVersions extends Vue {
	@helpCenterNamespace.Getter('versionsEntries')
	public versions!: HelpCenterVersionsEntry[];

	@helpCenterNamespace.State('fiContactInfo')
	public fiContactInfo!: HelpCenterFIContactInfo;

	private activeVersion: HelpCenterVersionsEntry | null = null;

	public formatDescription = HelpCenterHelper.formatVersionDescription;

	public getVersionTitle = HelpCenterHelper.getVersionEntryTitle;

	public getVersionReleasedOn = HelpCenterHelper.getVersionEntryReleasedOn;

	get activeVersionId(): string {
		return this.activeVersion?.sys.id || '';
	}

	mounted(): void {
		this.goToVersion(this.versions[0]);
	}

	public goToVersion(version: HelpCenterVersionsEntry): void {
		const [element] = this.$refs[version.sys.id] as Element[];

		if (element) {
			this.activeVersion = version;
			element.scrollIntoView();
		}
	}
}

